import * as types from './types';

const exportData = context => ({
  type: types.EXPORT_DATA,
  context,
});

const exportWidgetData = (context, metric) => ({
  type: types.EXPORT_WIDGET_DATA,
  context,
  metric,
});

export {
  exportData,
  exportWidgetData,
};
